import Image from "next/image";
import { ArrowRight } from "lucide-react";

export function HowItWorksSection() {
  const steps = [
    {
      icon: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/login_icon.png",
      title: "Log in",
      description: "Log in to the Swapper portal to access your personalized dashboard and start inviting friends to maximize your rewards!",
    },
    {
      icon: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/quests_icon.png",
      title: "Complete all quests and Tiers",
      description: "When you complete quests and advance through tiers in the Swapper portal, you can earn exciting rewards and bonuses. Dive into challenges and watch your progress soar!",
    },
    {
      icon: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/rewards_icon.png",
      title: "Get rewarded",
      description: "Use your earned points to redeem exclusive rewards, discounts, and perks. The more active you are, the greater the benefits!",
    },
  ];

  return (
    <section className="relative w-full bg-white py-12 md:py-16 lg:py-20">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-swapper-secondary mb-4">
            How It Works
          </h2>
          <p className="text-base md:text-lg text-swapper-secondary/70 max-w-2xl mx-auto">
            Get started with Swapper Portal in three simple steps
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center relative">
              {/* Icon */}
              <div className="relative w-16 h-16 md:w-20 md:h-20 mb-6">
                <Image
                  src={step.icon}
                  alt={step.title}
                  fill
                  className="object-contain"
                />
              </div>

              {/* Title */}
              <h3 className="text-lg md:text-xl font-bold text-swapper-secondary mb-3">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-sm md:text-base text-swapper-secondary/70">
                {step.description}
              </p>

              {/* Arrow (only between steps, hidden on mobile) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 -right-4 lg:-right-6">
                  <ArrowRight className="w-6 h-6 text-swapper-primary" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
